
import { MutationTypes, store } from "@/store";
import { computed, defineComponent, ref, watch } from "vue";

export default defineComponent({
  name: "fullscreen-spin",
  props: {
    exportType: {
      type: String,
      default: "",
    },
  },
  setup() {
    const percent = ref(0);
    const exporting = computed(() => store.state.exporting);
    const cancelExport = () => {
      store.commit(MutationTypes.SET_EXPORTING_STATE, false);
      location.reload();
    };
    return {
      percent,
      exporting,
      cancelExport,
    };
  },
});
